/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum ActionHint {
  ALLIN = 'ALLIN',
  BET = 'BET',
  BLANK = 'BLANK',
  CALL = 'CALL',
  CHECK = 'CHECK',
  FOLD = 'FOLD',
  RAISE = 'RAISE'
}

/**
 * ActionHint
 *
 * The hints of different play actions
 */
export const ActionHintEnumType = types.enumeration('ActionHint', [
  'ALLIN',
  'BET',
  'BLANK',
  'CALL',
  'CHECK',
  'FOLD',
  'RAISE'
])
